import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";
import { useEffect, useState, useRef } from "react";
import { useContext } from "react"
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import api from "../../services/api";
import CustomToolbar from '../../components/grid/CustomToolbar'
import SL_Button from '../../components/buttons/Button'
import detail_protocol_grid_columns from "./grid_columns/detail_protocol_grid_columns";
import { useNavigate } from "react-router-dom";
// import ProtocolFilters from './ProtocolFilters'
import { displayMessage } from "../../services/helper";
import { PlusOutlined, DeleteOutlined, FileSearchOutlined, DownloadOutlined } from '@ant-design/icons'
import { DatePicker, Form, Input, Modal, Popconfirm, Switch, Col, Checkbox } from "antd";
import moment from "moment";
import { MultiSelect } from "../../components/selects/MultiSelect";
import { CreateExerciseModal } from "../exercise/CreateExerciseModal";
import EDaysOfTheWeek from "../../enums/EDaysOfTheWeek";
import {Select} from "antd";
import ELanguages from "../../enums/ELanguages";
import AddExercise from "./modals/AddExercise";



export default function ListProtocol() {
    //COPIADO DE HOLIDAY, FALTA EDITAR TUDO
  const { Option } = Select;
    const {setShowLoading, user, enums, windowHeight, mobile_mode, currentProtocol} = useContext(GeneralContext)
    const gridRef = useGridApiRef()
    const DataGridProHeight = windowHeight * 0.7

    const [protocolDetails, setProtocolDetails] = useState([])
    const [exercises, setExercises] = useState([])
    const [isModalAddExerciseVisible, setIsModalAddExerciseVisible] = useState(false)
    const [isModalUpdateProtocolVisible, setIsModalUpdateProtocolVisible] = useState(false)


    const [editMode, setEditMode] = useState(false);
    const [name, setName] = useState(currentProtocol?.name || '');
    const [description, setDescription] = useState(currentProtocol?.description || '');
    const [language, setLanguage] = useState(currentProtocol?.language || '');
    const [formRef] = Form.useForm()
    const [selectedDownloadRow, setSelectedDownloadRow] = useState(null)
    const [isModalDownloadVisible, setIsModalDownloadVisible] = useState(false)

    // Adicionando o estado para controlar a seleção do exercício
    const [isExerciseSelected, setIsExerciseSelected] = useState(false);

    const [selectedDays, setSelectedDays] = useState([]);
    const daysOfWeek = Object.values(EDaysOfTheWeek ?? {}).map((day)=>{
      return {
        label: day.label,
        value: day.code,
      }
    }) ?? []
    

    const navigate = useNavigate();

    useEffect(() => {
        loadProtocolDetails()
    }, [])

    const loadProtocolDetails = async () => {
        try {
            setShowLoading(true)
            const rs = await api.protocols.findWithExercises(currentProtocol.id);
            const protocol = rs.data;
            gridRef.current.setSelectionModel([])
            const exerciseRows = protocol.Exercises.map(ex => ({
                id: ex.id,
                name: ex.name,
                description: ex.description,
                movieUrlApi: ex.movieUrlApi,
                audioApi: ex.audioApi,
                closingVideoApi:ex.closingVideoApi,
                intervalVideoApi:ex.intervalVideoApi,
                openingVideoApi:ex.openingVideoApi,
                replayVideoApi:ex.replayVideoApi,
                language:ex.language,
                parentProtocolId: protocol.id,
                scheduleDays: protocol.scheduleDays,
              }));
              setSelectedDays(protocol.scheduleDays ?? [])
              setProtocolDetails(exerciseRows);
        } finally {
            setShowLoading(false)
        }
    }

    const loadExercises = async () => {
        try {
            // setShowLoading(true)
            const rs = await api.exercise.listExercises();
            const exercise = rs.data;
            gridRef.current.setSelectionModel([])
              
              setExercises(rs.data);
        } finally {
            setShowLoading(false)
        }
    }

    const renderCustomToolBar = () => {
        return (<CustomToolbar />)
    }

    const handleOnOpenModalAddExecrise = () => {
        setIsModalAddExerciseVisible(true)
        loadExercises();
    }

    const handleOnDelete = async (data) => {
        try {
            setShowLoading(true)
            const payload = {
                name: currentProtocol.name,
                deleteExercises: [data.id]
            }

            await api.protocols.update(currentProtocol.id, payload)
            loadProtocolDetails()
        } finally {
            setShowLoading(false)
            alert(displayMessage('EXERCISE_SUCCESSFULLY_REMOVED'), 'success')
        }
    }

    const mountExerciseOptions = async e => {
        try {
            const { data } = await api.exercise.listForSelectOptions({
                protocol_id: currentProtocol.id,
                name: e,
                limit: 10,
                language: language
            });

            return data
        } catch (error) {
            console.log(error);
        }
    };

    const handleOnSelectExercise = async e => {
        try {
            if (e == undefined) {
                formRef.current.setFieldValue('exercise', null)
                return
            }
            formRef.current.setFieldsValue({
                exercise_description: e.label,
            })
        } catch (error) {
            console.log(error)
        }
    }


    /*Actions */
    const actionCancel = {
        field: 'cancel_action',
        headerName: displayMessage('CANCEL'),
        width: 100,
        sortable: false,
        align: 'center',
        renderCell: (params) => {
            return (
                <div>
                    <Popconfirm
                        zIndex={10001}
                        placement="bottomLeft"
                        title={displayMessage('WARNING_REMOVE_EXERCISE')}
                        onConfirm={() => handleOnDelete(params.row)}
                        okText={displayMessage('YES')}
                        cancelText={displayMessage('NO')}
                        disabled={user?.user_type != enums?.EUserTypes?.ADMIN?.code}
                    >
                        <SL_Button
                            style={{ background: 'red', borderColor: 'pink', color: 'pink', fontWeight: 'bold' }}
                            shape="circle"
                            icon={<DeleteOutlined />}
                            disabled={user?.user_type != enums?.EUserTypes?.ADMIN?.code}
                        >
                        </SL_Button>
                    </Popconfirm>

                </div>
            )
        },
        disableColumnSelector: true
    }
    const actionDownload = {
        field: 'download_action',
        headerName: `${displayMessage('DOWNLOAD')}`,
        width: 100,
        sortable: false,
        align: 'center',
        renderCell: (params) => {
          return (
            <div>
              <CreateExerciseModal
                currentDownloads={selectedDownloadRow}
                isModalVisible={isModalDownloadVisible}
                handleOnCloseModal={handleOnCloseDownloadModal}
                id={params.row.id}
              />
              <SL_Button
               onClick={(e) => {
                e.stopPropagation(); 
                setSelectedDownloadRow(params.row);   
                handleOnOpenDownloadModal();           
              }}
              
                style={{ background: 'purple', borderColor: 'pink', color: 'pink', fontWeight: 'bold' }}
                shape="circle"
                icon={<DownloadOutlined />}
              />
            </div>
          )
        },
        disableColumnSelector: true
      }


    /* Modals */

  


    const EditProtocol = props => {
        const [form] = Form.useForm()
        const [myProtocol, setMyProtocol] = useState(null)
        const [edit_mode, setEditMode] = useState(false)

        function loadMyProtocol() {
            setShowLoading(true)

            api.holiday.find(currentProtocol.id)
                .then(
                    rs => {
                        rs.data.holiday_date = moment(rs.data.holiday_date)
                        setMyProtocol(rs.data)
                        form.setFieldsValue(rs.data)
                    }
                )
                .finally(
                    setShowLoading(false)
                )
        }

        useEffect(() => {
            loadMyProtocol()
        }, [])

        const updateNewProtocol = payload => {
            setShowLoading(true)
            api.holiday.update(currentProtocol.id, payload).then(
                rs => {
                    setShowLoading(false)
                    alert(displayMessage('DEATAIL_HOLIDAY_TITLE'), 'success')
                    loadProtocolDetails()
                    setIsModalUpdateProtocolVisible(false)
                }
            )
        }

        const handleSetEditMode = () => {
            setEditMode(!edit_mode)
        }
        return (
            <Modal
                title={<div className="text-xl font-bold text-appian-blue">{displayMessage('DEATAIL_HOLIDAY_TITLE')} </div>}
                visible={isModalUpdateProtocolVisible}
                onCancel={() => setIsModalUpdateProtocolVisible(false)}
                centered={true}
                footer={[]}
                width={750}
                style={{ position: 'relative' }}
                bodyStyle={{ maxHeight: windowHeight * 0.8, overflow: 'auto' }}
            >
                <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end', alignItems: 'center' }}>
                    <Switch
                        onChange={handleSetEditMode}
                        style={{ height: 30, width: mobile_mode ? '100%' : null, maxWidth: 180, marginTop: mobile_mode ? 10 : 0 }}
                        unCheckedChildren={displayMessage('EDIT_HOLIDAY')}
                        checkedChildren={displayMessage('CANCEL')}
                        disabled={user?.user_type != enums?.EUserTypes?.ADMIN?.code}
                    />
                </div>
                <Form
                    form={form}
                    className='w-full flex flex-col gap-2 p-5'
                    onFinish={updateNewProtocol}
                    layout="vertical"
                    requiredMark='optional'
                >
                    <div style={{ display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', gap: 5, alignItems: 'center' }}>
                        <Form.Item
                            label={displayMessage('DESCRIPTION')}
                            name="description"
                            className={`w-full flex`}
                            style={{ flex: 1 }}
                            rules={[
                                { required: true },
                            ]}
                        >
                            <Input
                                type="description"
                                size='large'
                                placeholder={displayMessage('ENTER_DESCRIPTION')}
                                disabled={!edit_mode}
                            />
                        </Form.Item>
                        <Form.Item
                            label={displayMessage("HOLIDAYS_DATE")}
                            name="holiday_date"
                            className={`w-full flex`}
                            style={{ display: 'flex', flex: 1, maxWidth: 200, marginLeft: mobile_mode ? '' : 10, justifyContent: mobile_mode ? '' : 'flex-end' }}
                            rules={[
                                { required: true },
                            ]}
                        >
                            <DatePicker
                                style={{ display: 'flex', flex: 1 }}
                                size='large'
                                disabled={!edit_mode}
                            />
                        </Form.Item>
                    </div>
                    <SL_Button
                        type="primary"
                        size='large'
                        htmlType="submit"
                        className="border-appian-blue max-h-9 text-base w-full sticky bottom-[-20px]"
                        disabled={!edit_mode}
                    >
                        {displayMessage('UPDATE_HOLIDAY')}
                    </SL_Button>
                </Form>
            </Modal>
        )
    }

    const handleOnOpenDownloadModal = () => {
 
        setIsModalDownloadVisible(true);
      };
      
    const handleOnCloseDownloadModal = () => {
        setIsModalDownloadVisible(false);
        setSelectedDownloadRow(null);
      };
    const handleEditClick = () => {
        if (editMode) {
          
            if (language !== currentProtocol?.language, name !== currentProtocol?.name || description !== currentProtocol?.description || selectedDays.length !== currentProtocol?.scheduleDays?.length || !selectedDays.every(day => currentProtocol?.scheduleDays?.includes(day))) {
                const payload = {
                    name,
                    description,
                    selectedDays,
                     language
                };
                api.protocols.update(currentProtocol.id, payload)
                    .then(() => {
                        alert(displayMessage('UPDATE_PROTOCOL_SUCCESS'), 'success');
                        loadProtocolDetails();
                    })
                    .catch(error => {
                        console.error(error);
                        alert(displayMessage('ERROR_UPDATE_PROTOCOL'), 'error');
                    });
            }
        }
        setEditMode(!editMode);
    };

    return (
      <>
        {isModalAddExerciseVisible && <AddExercise handleOnSelectExercise={handleOnSelectExercise} isModalAddExerciseVisible={isModalAddExerciseVisible} language={language} loadProtocolDetails={loadProtocolDetails} setLanguage={setLanguage} mountExerciseOptions={mountExerciseOptions} setIsModalAddExerciseVisible={setIsModalAddExerciseVisible} />}

        {isModalUpdateProtocolVisible && <EditProtocol />}
        {/* <ProtocolFilters handleOnSearchSatusHistory={loadProtocolDetails} /> */}

        <div className="flex flex-col w-full">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              padding: 0,
              marginBottom: 15,
              color: "white",
              overflow: "hidden",
              border: "1px solid lightgrey",
            }}
          >
            {/* Header azul */}
            <div className="flex flex-1 justify-between p-2 bg-appian-blue gap-1">
              <span className="self-center font-medium text-white flex-1 text-center">
                {displayMessage("PROTOCOL_DETAILS")}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                background: "#efefef",
                padding: 5,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  padding: 5,
                  alignItems: "center",
                }}
              >
                {/* Input Name */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginRight: 5,
                  }}
                >
                  <div style={{ fontWeight: "bold", color: "#1b3663" }}>
                    {displayMessage("NAME")}:
                  </div>
                  <Input
                    style={{ width: 250 }}
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    disabled={!editMode}
                    placeholder={displayMessage("ENTER_NAME")}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginRight: 5,
                  }}
                >
                  <div style={{ fontWeight: "bold", color: "#1b3663" }}>
                    {displayMessage("DESCRIPTION")}:
                  </div>
                  <Input
                    style={{ width: 250 }}
                    type="text"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    // onChange={(e) =>
                    //   setCurrentExercise({
                    //     ...currentExercise,
                    //     description: e.target.value,
                    //   })
                    // }
                    disabled={!editMode}
                    placeholder={displayMessage("ENTER_DESCRIPTION")}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginRight: 5,
                  }}
                >
                <div style={{ fontWeight: "bold", color: "#1b3663" }}>
                    {displayMessage("LANGUAGE")}:
                  </div>
                <Select style={{ width: 250 }}
                        disabled={!editMode}
                        type="text"
                        placeholder={displayMessage('LANGUAGE')}
                        value={language}
                  onChange={(value) => setLanguage(value)}

                    >
               {Object.values(ELanguages).map((type) => (
    <Option key={type.code} value={type.code}>
        {type.description}
    </Option>
))}
                    </Select>
                    </div>
                <div className="flex flex-col">
              <div style={{ fontWeight: "bold", color: "#1b3663", marginBottom: 4 }}>
                  {displayMessage("DAYS_OF_WEEK")}:
              </div>
              <div className="flex flex-wrap gap-2">
                  {daysOfWeek.map((day) => (
                      <div
                          key={day.value}
                          className={`rounded-md border cursor-pointer transition-all duration-200 flex items-center gap-2 px-3 py-1.5 ${
                              selectedDays.includes(day.value)
                                  ? "border-blue-500 bg-blue-100 text-blue-800"
                                  : "border-gray-300 bg-white hover:bg-gray-50 text-gray-700"
                          }`}
                          onClick={() => {
                              if (!editMode) return; 
                              setSelectedDays((prev) =>
                                  prev.includes(day.value)
                                      ? prev.filter((val) => val !== day.value)
                                      : [...prev, day.value]
                              );
                          }}
                      >
                          <Checkbox
                              checked={selectedDays.includes(day.value)}
                              disabled={!editMode}
                              className="pointer-events-none"
                          />
                          <span className="font-medium text-sm select-none">
                              {day.label} 
                          </span>
                      </div>
                  ))}
              </div>
            </div>
            <SL_Button className="ml-3 mt-7" onClick={handleEditClick}>
                    {editMode ? displayMessage('SAVE') : displayMessage('EDIT')}
                </SL_Button>
              </div>
            </div>
          </div>
          <div
            className={`flex flex-1 justify-between p-2 bg-appian-blue gap-1 ${
              mobile_mode ? `flex-col` : `flex-row`
            } `}
          >
            <span className="self-center text-white flex-1 text-center font-medium">
              {displayMessage("EXERCISE_LIST")}
            </span>
            <div
              className={`flex gap-1 ${mobile_mode ? `flex-col` : `flex-row`}`}
            >
              <SL_Button
                type="default"
                className="items-center w-30 flex"
                onClick={handleOnOpenModalAddExecrise}
                icon={<PlusOutlined className={`text-base text-green-900`} />}
              >
                {displayMessage("CREATE_EXERCISE")}
              </SL_Button>
              
            </div>
          </div>

          <div style={{ height: DataGridProHeight, minHeight: 300 }}>
            <DataGridPro
              rows={protocolDetails}
              apiRef={gridRef}
              style={{ height: "100%" }}
              columns={detail_protocol_grid_columns.concat(actionCancel).concat(actionDownload)}
              pagination
              pageSize={100}
              components={{
                Toolbar: renderCustomToolBar,
              }}
              density="compact"
              disableMultipleSelection
            />
          </div>
        </div>
      </>
    );
}